/** Realtime stream question labels → TestInstanceData.DataKey (see TestInstanceRequestDataKeys). */
export const REALTIME_QUESTION_TO_DATA_KEY: Record<string, string> = {
  "first name": "FirstName",
  "last name": "LastName",
  "company name": "Company",
  "recruiter initials": "Initials",
  position: "Job",
  location: "Location",
  "location selection": "SiteId",
  "site select": "SiteId",
  job: "CompanyJobId",
  "job select": "CompanyJobId",
  initials: "Initials",
  supervisor: "Supervisor",
  "report recipient": "Supervisor",
  gender: "Gender",
  email: "Email",
  "birth city": "BirthCity",
  "birth country": "BirthCountry",
  "billing source": "BillingSource",
  facility: "Facility",
  uniqueid: "UniqueId",
  charge: "Charge",
  "parole officer": "ParoleOfficer",
  language: "Language",
  languageid: "LanguageId",
};

export const DATA_KEY_LABELS: Record<string, string> = {
  FirstName: "First Name",
  LastName: "Last Name",
  SiteId: "Site",
  SiteName: "Site",
  LanguageId: "Language",
  Language: "Language",
  Location: "Location",
  Job: "Job",
  CompanyJobId: "Job",
  Initials: "Initials",
  Supervisor: "Supervisor",
  UniqueId: "Unique ID",
  ClientIpAddress: "IP Address",
  ClientUserAgent: "User Agent",
  ClientAcceptLanguage: "Accept-Language",
  ClientBrowser: "Browser",
  ClientOS: "OS",
  ClientPlatform: "Platform",
  ClientBrowserLanguage: "Browser Language",
  ClientBrowserLanguages: "Browser Languages",
  ClientTimeZone: "Time Zone",
  ClientLocalTime: "Local Time",
  ClientScreenWidth: "Screen Width",
  ClientScreenHeight: "Screen Height",
  ClientColorDepth: "Color Depth",
  ClientPixelRatio: "Pixel Ratio",
  ClientReferrer: "Referrer",
  ClientPageUrl: "Page URL",
  ClientCookieEnabled: "Cookies Enabled",
  ClientOnline: "Online",
  ClientHardwareConcurrency: "CPU Cores",
  ClientDeviceMemory: "Device Memory (GB)",
  ClientMaxTouchPoints: "Touch Points",
  ClientCaptureSource: "Capture Source",
  ClientCapturedAtUtc: "Captured At (UTC)",
};

export const PREFERRED_DATA_KEY_ORDER = [
  "FirstName",
  "LastName",
  "SiteName",
  "SiteId",
  "CompanyJobId",
  "Job",
  "Location",
  "Language",
  "LanguageId",
  "Initials",
  "Supervisor",
  "Email",
  "UniqueId",
];

export const SCORING_DATA_KEYS = new Set([
  "CompanyScore",
  "ApplicantScore",
  "OverallScore",
  "AlgoVersion",
  "Reason",
  "Result",
  "ApplicantMessage",
  "CompanyMessage",
  "OverallMessage",
]);

const KNOWN_DATA_KEYS_BY_LOWER = new Map(
  [
    ...Object.keys(DATA_KEY_LABELS),
    ...PREFERRED_DATA_KEY_ORDER,
    ...Object.values(REALTIME_QUESTION_TO_DATA_KEY),
  ].map((key) => [key.toLowerCase(), key]),
);

export function normalizeFieldKey(value: unknown) {
  return String(value || "").trim().toLowerCase();
}

export function formatDataKeyLabel(dataKey: string) {
  if (DATA_KEY_LABELS[dataKey]) {
    return DATA_KEY_LABELS[dataKey];
  }
  return dataKey.replace(/([a-z])([A-Z])/g, "$1 $2").trim();
}

export function resolveRealtimeDataKey(question: unknown) {
  const normalized = normalizeFieldKey(question);
  if (!normalized) return "";
  if (REALTIME_QUESTION_TO_DATA_KEY[normalized]) {
    return REALTIME_QUESTION_TO_DATA_KEY[normalized];
  }
  return KNOWN_DATA_KEYS_BY_LOWER.get(normalized) || "";
}
